import React from 'react';
import useTranslation from '../../../../hooks/useTranslation';

const BrandLogo = () => {
	const { t } = useTranslation();
	return (
		<div>
			<span className="sr-only">{t('header.logo')}</span>
			<img className="min-w-[144px] w-full h-11 lg:h-16" src="/brand-logo.svg" alt={t('header.logo')} />
		</div>
	);
};
export default BrandLogo;